import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import KelebihanSODetail from "./kelebihanSODetail";
import {fetchKelebihanSO} from "../service";
import {contructQueryParam} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";

class KelebihanSO extends Component {
    constructor(props) {
        super(props);
    }

    handlingSetState = (callback) => {
        this.props.handleSetState(callback);
    }

    render() {
        return (
            <>
                <Tabs>
                    <TabList>
                        <Tab id="dengan_qr">Dengan QR</Tab>
                        <Tab id="tanpa_qr">Tanpa QR</Tab>
                    </TabList>
                    <TabPanel>
                        <KelebihanSODetail
                            tab="with_qr"
                            state={this.props.state}
                            onSetState={this.handlingSetState}
                            handleSubmit={this.props.handleSubmitKelebihan}
                            edit={this.props.state.dataKelebihan.edit}
                            {...this.props}
                        />
                    </TabPanel>
                    <TabPanel>
                        <KelebihanSODetail
                            tab="without_qr"
                            state={this.props.state}
                            onSetState={this.handlingSetState}
                            handleSubmit={this.props.handleSubmitKelebihan}
                            edit={this.props.state.dataKelebihan.edit}
                            {...this.props}
                        />
                    </TabPanel>
                </Tabs>
            </>
        )
    }
}

export default KelebihanSO;